import React, { useEffect, useState } from 'react'
import Button from '../../component/Button'
import classes from "./style.module.scss";
import { useLocation, useNavigate } from 'react-router-dom';
import SearchBox from '../../component/SearchBox';
import { Icons } from '../../assets';
import ProductList from './components/ProductList';
import ViewProduct from './components/ViewProduct';
import AddProduct from './components/AddProduct';
import GetUserPermission from '../../component/GetUserPermission';
import { BEARINGS, BULK_FILTRATION, Filters, KG_BEARINGS, KG_BULK_FILTRATION, KG_FILTERS, KG_TRUCK_SOLUTIONS, TRUCK_SOLUTIONS } from '../../helpers';

const ProductCatalog = () => {

    const productList = [
        { label: KG_FILTERS, value: Filters },
        { label: KG_TRUCK_SOLUTIONS, value: TRUCK_SOLUTIONS },
        { label: KG_BEARINGS, value: BEARINGS },
        { label: KG_BULK_FILTRATION, value: BULK_FILTRATION },
    ]

    const NAME = 'Name'
    const STATUS = 'Status'

    const dropdownList = [
        { label: NAME, value: [NAME] },
        { label: STATUS, value: [STATUS] },
    ]

    const [activeTab, setActiveTab] = useState(Filters)
    const [viewProduct, setViewProduct] = useState(false)
    const [isAddProduct, setIsAddProduct] = useState(false)
    const [searchInput, setSearchInput] = useState('')
    const [isEdit, setIsEdit] = useState(false)
    const location = useLocation();
    const navigate = useNavigate();
    const addPermission = GetUserPermission({ key: 'add' });

    useEffect(() => {
        const searchParams = new URLSearchParams(location.search)
        const category = location.search?.split(('?category='))?.at(1)?.split('?')[0]
        const id = searchParams.get('id') || location.search?.split(('?id='))?.at(1)?.split('?')[0]
        const type = searchParams.get('type') || location.search?.split(('?type='))?.at(1)?.split('&')[0]
        const refId = searchParams.get('refId') || location.search?.split(('&refId='))?.at(1)?.split('?')[0]
        if(category) {
            setActiveTab(category)
        }
        if (id) {
            setViewProduct(true)
            setIsAddProduct(false)
        } else if (type === 'create') {
            setViewProduct(false)
            setIsAddProduct(true)
        } else if (type === 'edit' && refId) {
            setViewProduct(false)
            setIsAddProduct(true)
        } else {
            setViewProduct(false)
            setIsAddProduct(false)
        }
    }, [location.search])

    const handleTabChange = (value) => {
        if (value) {
            setActiveTab(value)
            navigate(`?category=?${value}`)
        } else {
            setActiveTab(Filters)
            navigate(`?category=?${Filters}`)
        }
    }

    const handleChange = (value) => {
        setSearchInput(value)
    }

    const redirectTo = () => {
        navigate(`?type=create`)
    }

    return (
        <>
            {viewProduct && !isAddProduct ? (
                <ViewProduct tabName={activeTab} />) : !viewProduct && isAddProduct ? (
                    <AddProduct currentTab={activeTab} />
                ) : (
                <div className={`${classes.manageUserWrapper}`}>
                    <div className={`w-[100%] flex items-center justify-between`}>
                        <div className={`layout-title`}>Product Catalog</div>
                        <div className='flex items-center'>
                            <SearchBox value={searchInput} onChange={handleChange} placeholder={'Find by reference number...'} />
                            {addPermission &&
                                <Button text={`Add product`} className={'ml-5'} StartIcon={Icons.addIcon} smallBtn onClick={() => redirectTo()} style={{ pointerEvents: activeTab === Filters ? "auto" : activeTab === TRUCK_SOLUTIONS ? " auto" : "none", opacity: activeTab === Filters ? "1" : activeTab === TRUCK_SOLUTIONS ? " 1" : "0.5" }} />
                            }
                        </div>
                    </div>
                    <div className={`${classes.headerList} w-[100%] flex items-center`}>
                        {productList?.map(({ label, value }) => <div className={`${classes.headerTab} ${activeTab === value ? classes.activeTab : ''}`} onClick={() => handleTabChange(value)}>{label}</div>)}
                    </div>
                    <div>
                        <ProductList getTab={activeTab} searchInput={searchInput} />
                    </div>
                </div>
            )}

        </>
    )
}

export default ProductCatalog